export default __webpack_public_path__ + "static/soehne-web-extraleicht-kursiv-3bb2e68c898feba2b4c71c0bbd382bc2.woff2";